import gameABI from './game.json';
import tokenABI from './token.json';
// https://testnet.bscscan.com/address/0xA05f65e86ba5a51f257E6ECf5F2C4474044C9FE5#code
// https://bscscan.com/address/0x004cC128C52fe477B2714774BE0b6C3741794aa9#readContract
export const gameContractAddress = '0x004cC128C52fe477B2714774BE0b6C3741794aa9';
export const tokenContractAddress = '0x55d398326f99059fF775485246999027B3197955';
// WRONG export const gameContractAddress = '0xA05f65e86ba5a51f257E6ECf5F2C4474044C9FE5';
// WRONG export const tokenContractAddress = '0x55d398326f99059fF775485246999027B3197955';
export const gameContractABI = gameABI;
export const tokenContractABI = tokenABI;


// test smart contracts

// game contract
// https://testnet.bscscan.com/address/0x35AC3F2cAC83eBCf83930C8f9a78645f4536e8F0#code
// export const gameContractAddress = '0xD5a35360AB29F367c1ed73edc059f9FA4dca2F72';
// token contract
// https://testnet.bscscan.com/address/0x8beb65F2D73c6b60Fb387127f24EEbA8C20F0318#code
// export const tokenContractAddress = '0x8beb65F2D73c6b60Fb387127f24EEbA8C20F0318';